import { useEffect, useState } from "react";
import { vpAxios, money } from "../api";
import { toast } from "sonner";
import { Plus, MapPin } from "lucide-react";

export default function ClientesPage() {
  const [rows, setRows] = useState([]);
  const [busca, setBusca] = useState("");
  const [open, setOpen] = useState(false);
  const load = () => vpAxios.get("/vaipede/clientes").then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const salvar = async (data) => {
    try { await vpAxios.post("/vaipede/clientes", data); toast.success("Salvo"); setOpen(false); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  const filtrados = rows.filter(c => `${c.nome} ${c.whatsapp} ${c.email}`.toLowerCase().includes(busca.toLowerCase()));

  return (
    <div data-testid="vaipede-clientes">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-black">Clientes</h1>
          <p className="text-sm text-neutral-500">{rows.length} cadastrados</p>
        </div>
        <button onClick={() => setOpen(true)} className="px-4 py-2.5 rounded-xl bg-[#EA1D2C] text-white font-bold text-sm flex items-center gap-2">
          <Plus className="w-4 h-4"/> Novo cliente
        </button>
      </div>

      <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="🔎 Buscar..." className="w-full px-4 py-2.5 rounded-xl border border-neutral-200 mb-4"/>

      <div className="bg-white rounded-2xl border border-neutral-200 overflow-hidden">
        {filtrados.length === 0 && <p className="text-sm text-neutral-500 text-center py-10">Nenhum cliente.</p>}
        <div className="divide-y divide-neutral-100">
          {filtrados.map(c => (
            <div key={c.id} className="p-4 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-red-100 text-[#EA1D2C] grid place-items-center font-bold">{(c.nome || "?")[0]}</div>
              <div className="flex-1 min-w-0">
                <div className="font-bold truncate">{c.nome}</div>
                <div className="text-xs text-neutral-500 truncate">
                  {c.whatsapp || "—"}{c.endereco ? ` · ${c.endereco}` : ""}
                  {(c.latitude && c.longitude) ? <span className="ml-1 text-emerald-600 inline-flex items-center gap-0.5"><MapPin className="w-3 h-3"/>GPS</span> : ""}
                </div>
              </div>
              <div className="text-right text-sm">
                <div className="font-black text-[#EA1D2C]">{money(c.gasto_total)}</div>
                <div className="text-xs text-neutral-500">{c.pedidos_total || 0} pedidos</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {open && <ClienteModal onSave={salvar} onClose={() => setOpen(false)}/>}
    </div>
  );
}

function ClienteModal({ onSave, onClose }) {
  const [f, setF] = useState({ nome: "", whatsapp: "", email: "", endereco: "", bairro: "", cidade: "", latitude: null, longitude: null });
  const [gps, setGps] = useState(false);
  const pegarLoc = () => {
    if (!navigator.geolocation) return toast.error("Sem GPS");
    setGps(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => { setF({...f, latitude: pos.coords.latitude, longitude: pos.coords.longitude}); toast.success("Localização capturada"); setGps(false); },
      () => { toast.error("Não foi possível obter localização"); setGps(false); },
    );
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-4" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-md p-5">
        <h2 className="font-black text-lg mb-4">Novo cliente</h2>
        <div className="space-y-2">
          <input value={f.nome} onChange={e => setF({...f, nome: e.target.value})} placeholder="Nome *" className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm"/>
          <input value={f.whatsapp} onChange={e => setF({...f, whatsapp: e.target.value})} placeholder="WhatsApp" className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm"/>
          <input value={f.email} onChange={e => setF({...f, email: e.target.value})} placeholder="Email" className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm"/>
          <input value={f.endereco} onChange={e => setF({...f, endereco: e.target.value})} placeholder="Endereço" className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm"/>
          <button onClick={pegarLoc} disabled={gps} className="w-full py-2.5 rounded-xl bg-emerald-50 text-emerald-700 font-bold text-sm border border-emerald-200 flex items-center justify-center gap-2">
            <MapPin className="w-4 h-4"/> {f.latitude ? "✓ Localização capturada" : (gps ? "Buscando..." : "Adicionar minha localização")}
          </button>
        </div>
        <div className="flex gap-2 mt-4">
          <button onClick={onClose} className="flex-1 py-2.5 rounded-xl bg-neutral-100 font-bold text-sm">Cancelar</button>
          <button onClick={() => onSave(f)} className="flex-1 py-2.5 rounded-xl bg-[#EA1D2C] text-white font-bold text-sm">Salvar</button>
        </div>
      </div>
    </div>
  );
}
